import {Store} from '@reatom/core'
import {getTime, hoursToMilliseconds} from 'date-fns'
import {indexBy} from 'ramda'
import {getApi} from '../../api'
import { createPrimitiveAtom } from '@reatom/core/primitives'

let lastInitTimestamp: number | null

export interface TermsOfPaymentData {
  id: string
  title: string
}

export const termsOfPaymentAtom = createPrimitiveAtom<Record<string, TermsOfPaymentData>>({})

export async function updateTermsOfPaymentAtom({dispatch}: Store) {
  if (
    lastInitTimestamp &&
    lastInitTimestamp + hoursToMilliseconds(2) > getTime(new Date())
  ) {
    return
  }
  const data = await getApi().listsApi.getTermsOfPayment()
  const record = indexBy(x => x.id, data)
  dispatch(termsOfPaymentAtom.set(record))
  lastInitTimestamp = getTime(new Date())
  return record
}